import { APP_INITIALIZER, Provider, inject } from '@angular/core';
import { NavController } from '@ionic/angular';
import { DeepLink } from '../services/deeplink/deeplink.service';

export const DeepLinkInitializer: Provider = {
  provide: APP_INITIALIZER,
  useFactory: () => {
    const deeplink = inject(DeepLink);
    const nav = inject(NavController);

    return async () => {
      deeplink.data$.subscribe(data => {
        nav.navigateRoot(data.fullPath);
      });
    };
  },
  multi: true,
};
